export const IMAGES_URL = "images/";
export const ICONS_URL = IMAGES_URL + "icons/";
export const AVATARS_IMAGES_ROOT='images/avatar/';